<template>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th></th>
          <th
            v-for="platform in platforms"
            :key="platform.id"
            class="text-center"
            :colspan="value[platform.name] ? value[platform.name].length : 1"
          >
            {{ platform.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>min</td>
          <template
            v-for="platform in platforms"
          >
            <template v-if="value[platform.name]">
              <td
                v-for="(extremums, index) in value[platform.name]"
                :key="platform.id + ' index ' + index"
                class="text-center"
              >
                {{ extremums.min || 0 }}
              </td>
            </template>
            <template v-else>
              <td class="text-center">0</td>
            </template>
          </template>
        </tr>
        <tr>
          <td>max</td>
          <template
            v-for="platform in platforms"
          >
            <template v-if="value[platform.name]">
              <td
                v-for="(extremums, index) in value[platform.name]"
                :key="platform.id + ' index ' + index"
                class="text-center"
              >
                {{ extremums.max }}
              </td>
            </template>
            <template v-else>
              <td class="text-center">0</td>
            </template>
          </template>
        </tr>
        <tr>
          <td>color</td>
          <template
            v-for="platform in platforms"
          >
            <template v-if="value[platform.name]">
              <td
                v-for="(extremums, index) in value[platform.name]"
                :key="platform.id + ' index ' + index"
                class="text-center"
              >
                <div
                  class="color elevation-3"
                  :style="{ backgroundColor: extremums.color }"
                />
              </td>
            </template>
            <template v-else>
              <td class="text-center">
                <div
                  class="color elevation-3"
                  :style="{ backgroundColor: 'white' }"
                />
              </td>
            </template>
          </template>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    platforms() {
      return this.$store.state.platforms;
    }
  },
}
</script>

<style scoped>
  .color {
    display: inline-block;
    border: 4px solid white;
    border-radius: 50% 50%;
    width: 24px;
    height: 24px;
  }
</style>